<template>
  <div v-if="footerButton.length" class="base-dialog-footer">
    <el-button
      v-for="btn in footerButton"
      :key="btn.name"
      v-bind="btn"
      @click="handleBtnClick(btn.key)"
    >{{ btn.name }}</el-button>
  </div>
</template>

<script>
export default {
  name: 'BaseDialgFooter',
  props: {
    footerButton: {
      type: Array,
      default: () => [
        { type: 'default', name: '取消', key: 'cancel' },
        { type: 'primary', name: '确定', key: 'confirm' }
      ]
    }
  },
  data() {
    return {}
  },
  methods: {
    handleBtnClick(key) {
      this.$emit('footer', key)
    }
  }
}
</script>

<style lang="scss" scoped>
.base-dialog-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px;
}
</style>
